"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChunkHeader = exports.IndexEntry = exports.ChunkInfo = exports.ConnectionInfo = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConnectionInfo = function ConnectionInfo() {
  _classCallCheck(this, ConnectionInfo);

  this.id = -1;
  this.topic = '';
  this.datatype = '';
  this.md5sum = '';
  this.msg_def = '';
  this.header = null;
};

exports.ConnectionInfo = ConnectionInfo;

var ChunkInfo = function ChunkInfo() {
  _classCallCheck(this, ChunkInfo);

  this.start_time = null;
  this.end_time = null;
  this.pos = 0;
  this.connection_counts = {};
};

exports.ChunkInfo = ChunkInfo;

var IndexEntry = function IndexEntry() {
  _classCallCheck(this, IndexEntry);

  this.time = null;
  this.chunk_pos = 0;
  this.offset = 0;
};

exports.IndexEntry = IndexEntry;

var ChunkHeader = function ChunkHeader() {
  _classCallCheck(this, ChunkHeader);

  this.compression = '';
  this.compressed_size = 0;
  this.uncompressed_size = 0;
};

exports.ChunkHeader = ChunkHeader;